import styled, { css, keyframes } from 'styled-components';
import lightTheme from '../theme/lightBaseTheme.js';

const bannerTemplate = css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;
const shimmerTransition = keyframes`
    from {
        transform: translate3d(-100%, 0, 0);
    }
    to {
        transform: translate3d(100%, 0, 0);
    }
`;
// https://github.com/styled-components/stylelint-processor-styled-components/issues/247#issuecomment-525524944
const animationRule = css([
    "",
    " 2000ms infinite linear;"
], shimmerTransition);
function getTransparentColor(theme) {
    const lightModeTransparent = "rgba(255, 255, 255, 0)";
    const darkModeTransparent = "rgba(0, 0, 0, 0)";
    if (theme.colors.Background === lightTheme.colors.Background) {
        return lightModeTransparent;
    }
    return darkModeTransparent;
}
const ShimmerContainer = styled.div.withConfig({
    displayName: "ShimmerEffect.styles__ShimmerContainer",
    componentId: "sc-223e9ba5-0"
})`
    ${bannerTemplate}
    overflow: hidden;
    /* overflow:hidden fix for Safari */
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-mask-image: -webkit-radial-gradient(white, black);

    ${({ theme  })=>css`
        background-color: ${theme.colors.Background};

        :before {
            ${bannerTemplate}
            content: '';
            background-color: ${theme.colors["Level 1"]};
        }

        :after {
            ${bannerTemplate}
            content: '';
            transform: translate3d(-100%, 0, 0);
            animation: ${animationRule};
            background: linear-gradient(
                90deg,
                ${getTransparentColor(theme)} 0%,
                ${theme.colors.Background} 50%,
                ${getTransparentColor(theme)} 100%
            );
        }
    `}
`;

export { ShimmerContainer };
